import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort, PageEvent, Sort } from '@angular/material';

import { RequestFeedback, PaginationModel } from '@app/core';
import * as fromStore from '@app/core/store';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-request-feedback-list',
  templateUrl: './request-feedback-list.component.html',
  styleUrls: ['./request-feedback-list.component.scss']
})
export class RequestFeedbackListComponent implements OnInit {

  @Input() list: RequestFeedback[];
  @Input() listCount: number;
  @Output() listPageEvent = new EventEmitter<PaginationModel>();
  @Output() onSelectEvent = new EventEmitter<RequestFeedback>();
  @Output() onExportEvent = new EventEmitter();

  dataSource: MatTableDataSource<RequestFeedback> | null;
  displayedColumns = ['requestNumber', 'answer', 'feedbackByName', 'feedbackDate', 'remarks' ];
  pagination = new PaginationModel();


  constructor(private store: Store<fromStore.State>) { }

  ngOnInit() {
    //this.dataSource = new MatTableDataSource<RequestFeedback>(this.list);
  }

  ngOnChanges() {
    this.dataSource = new MatTableDataSource<RequestFeedback>(this.list);
  }

  switchPage(event: PageEvent) {
    this.pagination.change(event);
    this.listPageEvent.emit(this.pagination);
  }
  onSortChange(event: Sort) {
    this.pagination.sort(event);
    this.listPageEvent.emit(this.pagination);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/request-feedback-list/request-feedback-list.component.ts